import React from 'react';

import { Button } from '../../components/ui';
import { TransferInformation } from '../atoms';

export function BankTransfer({
  transferRefNo,
  amount,
  currency,
  confirmPayment,
  canPayOnline,
  payOnline,
}) {
  const submitPayment = () => {
    confirmPayment(
      'offline',
      { bank_transfer_code: transferRefNo }
    );
  }

  return (
    <section id="payment" className="checkout-transfer">
      {/* TransferInformation is shared with /order and stays on the legacy
          classes until that page is migrated too — out of the M51A slice. */}
      <div data-legacy-shared="transfer-information">
        <TransferInformation amount={amount} currency={currency} reference={transferRefNo} />
      </div>

      <Button size="lg" onClick={submitPayment}>Complete Purchase</Button>

      {canPayOnline && (
        <p className="checkout-transfer__online">
          Or click here to{' '}
          <button type="button" className="checkout-transfer__link" onClick={payOnline}>pay online</button>.
        </p>
      )}
    </section>
  );
};
